// @flow

import * as Sentry from '@sentry/react';

import { ErrorBoundary } from 'react-error-boundary';

export function sendErrorReport(
  error: Error,
  info: { componentStack: string, ... },
): void {
  Sentry.captureException(error, { extra: info });
}

export { ErrorBoundary };
